export type AuthState = "checking" | "authenticated" | "anonymous";
export type AccountCustomer = {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  pendingEmail?: string | null;
  emailVerified: boolean;
  phone?: string | null;
  newsletter: boolean;
  defaultAddressId?: string | null;
};
export type AccountFieldError = {
  field: string;
  code: string;
  message: string;
};
export type AccountError = {
  code: string;
  message: string;
  fieldErrors: AccountFieldError[];
  retryAfterSeconds?: number | null;
};
export type AccountSession = {
  state: "AUTHENTICATED" | "ANONYMOUS";
  customer: AccountCustomer | null;
  verificationRequired: boolean;
};
export type AccountResult = {
  ok: boolean;
  error: AccountError | null;
  session: AccountSession;
};

export function passwordByteLength(value: string): number {
  if (typeof TextEncoder !== "undefined")
    return new TextEncoder().encode(value).length;
  return unescape(encodeURIComponent(value)).length;
}

export function safeReturnTo(value: unknown, fallback = "/account"): string {
  if (
    typeof value !== "string" ||
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("\\")
  )
    return fallback;
  try {
    const parsed = new URL(value, "https://storefront.invalid");
    return parsed.origin === "https://storefront.invalid" &&
      !parsed.username &&
      !parsed.password
      ? `${parsed.pathname}${parsed.search}${parsed.hash}`
      : fallback;
  } catch {
    return fallback;
  }
}
export function fieldErrors(
  error: AccountError | null
): Record<string, string> {
  return Object.fromEntries(
    (error?.fieldErrors || []).map((item) => [item.field, item.message])
  );
}
